module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_8.9b2550c3.png";